import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=7f60afa6&"
import script from "./Message.vue?vue&type=script&lang=js&"
export * from "./Message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f60afa6')) {
      api.createRecord('7f60afa6', component.options)
    } else {
      api.reload('7f60afa6', component.options)
    }
    module.hot.accept("./Message.vue?vue&type=template&id=7f60afa6&", function () {
      api.rerender('7f60afa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/View/Message.vue"
export default component.exports